import React from "react";
import {
  BaseEdge,
  getBezierPath,
  EdgeProps,
} from "reactflow";

const standardEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style,
  label,
  data,
}) => {
  // Calculate the bezier path for the edge
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  // Colors & animation flag from edge.data
  const edgeColor = data?.colour_primary ?? data?.colorprimary ?? style?.stroke ?? "#000000";
  const textColor = data?.colour_text ?? style?.color ?? "#ffffff";

  const isAnimated = data?.animated || false;
  
  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          stroke: edgeColor,
          strokeWidth: 3,
          strokeDasharray: isAnimated ? "8 4" : "0",
          animation: isAnimated
            ? "dashAnimation 1.5s linear infinite"
            : "none",
          ...style,
        }}
      />

      {/* CSS animation for animated edges */}
      <style>
        {`
          @keyframes dashAnimation {
            to {
              stroke-dashoffset: -12;
            }
          }
        `}
      </style>
    </>
  );
};

export default standardEdge;
